import React, { Fragment, Suspense, useMemo } from 'react'
import Grid from '@material-ui/core/Grid'
import injectStyles from 'react-jss'

import { GridItem } from 'Components/Page/StatsPageWrapper'

import { useChartsLogic, formatChartData } from './utils'
import Loader from './components/Loader'
import ChartHeader from './components/ChartHeader'

import styles from './styles'

const Chart = React.lazy(() =>
  import(/* webpackChunkName: 'highcharts' */ 'Components/Chart'),
)

const EvolutionOverTheTimeChart = ({
  classes,
  data,
  chartDataHash,
  chartWeeks,
  chartMetrics,
  currencySign,
}) => {
  const chartOptions = useMemo(
    () => ({
      xAxis: {
        categories: data.coordinateX,
        allowDecimals: false,
      },
      tooltip: {
        formatter: function() {
          const data = formatChartData(
            chartDataHash[`${this.series.name}|${this.key}`],
            currencySign,
          )

          return `
          <span>City - ${this.series.name}</span>
          <br>
          <span>Week - ${this.key}</span>
          ${data
            .map(([key, value]) => `<br><span>${key} - ${value}</span>`)
            .join('')}`
        },
      },
    }),
    [data, chartDataHash],
  )

  const {
    options,
    metrics,
    weekFrom,
    weekTo,
    handleFormChange,
    form,
  } = useChartsLogic({
    chartOptions,
    data,
    chartWeeks,
    chartMetrics,
  })

  return (
    <Fragment>
      <h1>Evolution over the time</h1>
      <GridItem>
        <Suspense fallback={<Loader />}>
          <Grid container>
            <Grid item xs={12}>
              <ChartHeader
                form={form}
                classes={classes}
                handleFormChange={handleFormChange}
                metrics={metrics}
                weekFrom={weekFrom}
                weekTo={weekTo}
              />
            </Grid>
            <Grid item xs={12}>
              <Chart options={options} />
            </Grid>
          </Grid>
        </Suspense>
      </GridItem>
    </Fragment>
  )
}

export default injectStyles(styles)(EvolutionOverTheTimeChart)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/HighchartsCharts/EvolutionOverTheTimeChart.js